import React from 'react';
import FreeShippingProgressBar, { IFreeShippingStatus } from './free_shipping_progress_bar';
import classNames from 'classnames';

export interface IProps {
  statuses: IFreeShippingStatus[];
}

export function FreeShippingProgressBarContainer({ statuses }: IProps) {
  function ProgressBars() {
    return (
      <>
        {statuses.map((status, index) => (
          <div
            key={index}
            className={classes(statuses, index)}
          >
            <FreeShippingProgressBar
              thresholdMet={status.thresholdMet}
              percentProgress={status.percentProgress}
              amountRemainingDisplay={status.amountRemainingDisplay}
              displayProgressBar={status.displayProgressBar}
              shopName={status.shopName}
              shopSlug={status.shopSlug}
            />
          </div>
        ))}
      </>
    );
  }

  if (!statuses.length) { return null; }

  // Each FreeShippingProgressBar handles its own event tracking. If the all progress bars are not to be displayed,
  // we will still trigger renders for each (all of which will be empty/null renders) so that qualifying events are logged.
  if (statuses.every(status => !status.displayProgressBar)) { return <ProgressBars />; }

  return (
    <div className="scaling-mtb-3">
      <section className="site-module">
        <div className="site-module__content">
          <ProgressBars />
        </div>
      </section>
    </div>
  );
}

function classes(statuses: IFreeShippingStatus[], index: number) {
  const isBottomRow = index === statuses.length - 1;

  return classNames({ 'mb-2 pb-2 bdb-1 bd-primary': !isBottomRow });
}

export default FreeShippingProgressBarContainer;
